import script from "./ViaggiTabView.vue?vue&type=script&setup=true&lang=js"
export * from "./ViaggiTabView.vue?vue&type=script&setup=true&lang=js"

import "./ViaggiTabView.vue?vue&type=style&index=0&id=2955e7f8&scoped=true&lang=css"

import exportComponent from "C:\\Source\\Tms\\TmsUI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2955e7f8"]])

export default __exports__